<template>
    <el-form class="mt-20 search-area" :inline="true" label-width="75px">
        <div>
            <template v-for="(item, index) in fieldArr">
                <el-form-item :label="item.label">
                    <input-custom v-if="item.mode === 'input'" v-model.trim="ruleForm[item.name]"
                                  :placeholder="`请输入${item.label}`"></input-custom>
                    <el-select :ref="`${item.name}Select`" filterable v-if="item.mode === 'select'" clearable
                               v-model="ruleForm[item.name]"
                               :placeholder="`请选择${item.label}`">
                        <el-option v-for="(subItem, subIndex) in item.arr || selectMap[item.filter]"
                                   :key="subItem.value" :label="subItem.text" :value="subItem.value"></el-option>
                    </el-select>
                </el-form-item>
            </template>
            <slot></slot>
        </div>
        <el-form-item>
            <span slot="label">&nbsp;</span>
            <el-button class="search-btn" @click="submitForm()" type="primary">搜索</el-button>
            <el-button class="search-btn" @click="clearAll()">清空</el-button>
            <slot name="operation"></slot>
        </el-form-item>
    </el-form>
</template>

<script>
    import InputCustom from 'components/inputCustom'
    import selectMapMixin from 'mixins/selectMapMixin'
    import {dateFormat} from 'modules/tools'

    const BaseFieldArr = [{
        filter: '',
        label: '学校名称',
        mode: 'input',
        name: 'name'
    }, {
        filter: 'WB_PROVINCE_ALL_WITH_CITY',
        label: '省份名称',
        mode: 'select',
        name: 'provinceId'
    }, {
        arr: [],
        label: '城市名称',
        mode: 'select',
        name: 'cityId'
    }, {
        filter: 'WB_SCHOOL_TYPES',
        label: '学校类型',
        mode: 'select',
        name: 'type'
    }, {
        filter: 'WB_SCHOOL_LEVEL',
        label: '学校档位',
        mode: 'select',
        name: 'sLevel'
    }]
    let fieldArr = JSON.parse(JSON.stringify(BaseFieldArr)),
        arrToObj = (arr) => {
            let temp = {}
            arr.forEach(field => {
                temp[field.name] = ''
            })
            return temp
        }

    export default {
        name: 'SearchArea',
        components: {InputCustom},
        mixins: [selectMapMixin],
        props: {
            mode: {
                type: String,
                default: 'append' // append追加/cover覆盖
            },
            fields: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
            'ruleForm.provinceId' (value) {
                this.provinceChange(value)
            },
            selectMap (value) {
                this.provinceChange(this.ruleForm.provinceId)
            }
        },
        data () {
            this.getFieldArr()
            let ruleForm = arrToObj(fieldArr)
            return {
                fieldArr,
                ruleForm
            }
        },
        computed: {
            isExam () {
                return ['interviewList', 'writtenList', 'entryList'].indexOf(this.$route.name) > -1
            }
        },

        methods: {
            submitForm () {
                let query = {}
                Object.keys(this.ruleForm).forEach(key => {
                    query[key] = this.getValueByArr(this.ruleForm[key])
                })
                query = Object.assign({}, this.$parent.searchData, query, {
                    pageIndex: 1,
                    time: Date.now()
                })
                this.$router.push({query})
                // this.$emit('submit', this.ruleForm)
            },
            clearAll () {
                Object.keys(this.ruleForm).forEach(key => {
                    this.ruleForm[key] = Array.isArray(this.ruleForm[key]) ? [] : ''
                })
            },
            getFieldArr () {
                fieldArr = fieldArr.concat(this.fields)
                if (this.mode === 'cover') {
                    fieldArr = this.fields
                }
                return fieldArr
            },
            getValueByArr (value) {
                return Array.isArray(value) ? value.join(',') : (Object.prototype.toString.call(value) === '[object Date]' ? dateFormat(value) : value.replace(/\s+/g, ',').replace(/,,/g, ','))
            },
            provinceChange (value) {
                let target = []
                if (this.selectMap.WB_PROVINCE_ALL_WITH_CITY) {
                    this.selectMap.WB_PROVINCE_ALL_WITH_CITY.forEach((item, index) => {
                        if (item.value === value) {
                            target = item.list
                        }
                    })
                    let isExist = false
                    if (target.length && this.ruleForm.cityId) {
                        isExist = target.filter(item => item.value === String(this.ruleForm.cityId)).length
                    }
                    this.fieldArr[2].arr = target
                    !isExist && (this.ruleForm.cityId = '')
                }
            }
        },
        mounted () {
            Object.keys(this.ruleForm).forEach(key => {
                if (this.$route.query[key]) {
                    this.ruleForm[key] = Array.isArray(this.ruleForm[key]) ? this.$route.query[key].split(',') : this.$route.query[key]
                }
            })
        },
        created () {
            fieldArr = JSON.parse(JSON.stringify(BaseFieldArr))
        }
    }
</script>

<style type="text/css" lang="scss">
    .search-area {
        .el-form--inline {
            .el-form-item {
                margin-right : 25px;
            }

            .el-form-item__content, .el-select, .el-date-editor.el-input {
                width : 300px;
            }
            .el-select {
                > .el-select__tags {
                    > span {
                        line-height : 30px;
                        display     : block;
                        white-space : nowrap;
                        overflow    : auto;
                    }
                }
            }
            .search-btn {
                padding : 10px 40px;
                + .search-btn {
                    margin-left : 30px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// searchArea.vue?48afe8d8